import React, { useRef, useState, useEffect } from 'react';
import { QuoteIcon, StarIcon, MapPinIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { testimonials } from '../data/testimonials';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/twDkv3KLYi1xBPVku13hUt/image.png', 'https://cdn.magicpatterns.com/uploads/p8htYw7SbDhxH9LihXw5a6/image.png', 'https://cdn.magicpatterns.com/uploads/efyQQMP6VqqALMfJ1oHxd6/image.png', 'https://cdn.magicpatterns.com/uploads/1jJdiGSu2UrLaVTLzntEpZ/image.png', 'https://cdn.magicpatterns.com/uploads/gEsSrk7daJ4nKbRHfQCer7/image.png', 'https://cdn.magicpatterns.com/uploads/22imC5sXcgKAcDy2uu4ZK6/image.png', 'https://cdn.magicpatterns.com/uploads/pxk71ycXdaBRjcaUH1yb4K/image.png', 'https://cdn.magicpatterns.com/uploads/dd6KSU1LNoVb6mQzrCHxnW/image.png', 'https://cdn.magicpatterns.com/uploads/xqRpvLBWeJPAAVxcvnYucs/image.png'];
export function Testimonials() {
  const scrollRef = useRef<HTMLUListElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const checkScroll = () => {
    if (scrollRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(Math.ceil(scrollLeft + clientWidth) < scrollWidth);
    }
  };
  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, []);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = scrollRef.current.clientWidth * 0.8;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full overflow-hidden bg-cream py-16 lg:py-24" data-id="element-201" data-mp="1ith2vu3vrqo6">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-202" data-mp="1nnbjups3prjk">
        <div className="flex items-end justify-between gap-4" data-id="element-203" data-mp="1xiipsomnt6f0">
          <SectionHeading overline="Community" size="lg" align="left" title={<>
                They tried it.{' '}
                <span className="italic text-terracotta-500" data-id="element-205" data-mp="1ofhqb6saudkb">They loved it.</span>
              </>} data-id="element-204" data-mp="1xfmtf4qgmpso" />
          <div className="hidden gap-2 sm:flex" data-id="element-206" data-mp="1ej4ua29a7nme">
            <button onClick={() => scroll('left')} disabled={!canScrollLeft} className="flex h-10 w-10 items-center justify-center rounded-full border border-gold-200/70 bg-bone text-sage-800 transition-colors disabled:opacity-50 hover:bg-gold-100" data-id="element-207" data-mp="1ejws7jqcpxfu">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-208" data-mp="10t1he1wal69m" />
            </button>
            <button onClick={() => scroll('right')} disabled={!canScrollRight} className="flex h-10 w-10 items-center justify-center rounded-full border border-gold-200/70 bg-bone text-sage-800 transition-colors disabled:opacity-50 hover:bg-gold-100" data-id="element-209" data-mp="vswvtxgj1lcj">
              <ChevronRightIcon className="h-5 w-5" data-id="element-210" data-mp="37expx7z52prl" />
            </button>
          </div>
        </div>
      </div>

      <ul ref={scrollRef} onScroll={checkScroll} className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-8 sm:px-8" data-id="element-211" data-mp="3cgenoumbtw3y">
        {testimonials.map(item => <li key={item.name} className="w-[85vw] flex-none snap-center sm:w-[400px]" data-id="element-212" data-mp="2js90803w1t0f">
            <figure className="flex h-full flex-col justify-between rounded-3xl border border-gold-200/60 bg-bone p-7 transition-[transform,box-shadow] duration-200 ease-soft hover:-translate-y-1 hover:shadow-[0_22px_44px_-30px_rgba(56,52,44,0.6)]" data-id="element-213" data-mp="2sr48riuenf6w">
              <div data-id="element-214" data-mp="20z584j6bjo7x">
                <div className="flex items-center justify-between" data-id="element-215" data-mp="20zofj5yceu7p">
                  <div className="flex gap-0.5" aria-hidden="true" data-id="element-216" data-mp="250gpk1f1h351">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" data-id="element-217" data-mp="1lusmpm4hu7mg" data-mpi={i} />)}
                  </div>
                  <QuoteIcon className="h-5 w-5 text-gold-200" aria-hidden="true" data-id="element-218" data-mp="1voj8ukd5e5yz" />
                </div>
                <blockquote className="mt-5 text-[15px] leading-relaxed text-sage-800" data-id="element-219" data-mp="24m3a3tb0g29l">
                  “{item.quote}”
                </blockquote>
              </div>
              <figcaption className="mt-8 flex items-center gap-3.5 border-t border-gold-200/60 pt-5" data-id="element-220" data-mp="2em3wjo46eyi0">
                <img src={item.avatar} alt="" className="h-11 w-11 rounded-full object-cover ring-2 ring-gold-200" data-id="element-221" data-mp="29m7tps77td41" />
                <div data-id="element-222" data-mp="f8q5s42wee8h">
                  <p className="text-[14px] font-semibold text-sage-800" data-id="element-223" data-mp="f9i07bkre5x6">
                    {item.name}
                  </p>
                  <p className="mt-0.5 flex items-center gap-1 text-[12px] text-terracotta-500" data-id="element-224" data-mp="2qwlhok1hiune">
                    <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-225" data-mp="2vu3h9jtm3xiq" />
                    {item.location}
                  </p>
                </div>
              </figcaption>
            </figure>
          </li>)}
      </ul>

      {/* Auto-scrolling Image Carousel */}
      <div className="relative mt-10 w-full overflow-hidden" data-id="element-226" data-mp="28493n01gy4xf">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-cream to-transparent sm:w-32" data-id="element-227" data-mp="2c6notqsm1grv" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-cream to-transparent sm:w-32" data-id="element-228" data-mp="1y86481y04ke6" />
        
        <div className="flex w-max animate-[marquee_40s_linear_infinite] gap-3 sm:gap-4" data-id="element-229" data-mp="2382a66q9elwd">
          {/* Double the images for seamless looping */}
          {[...CAROUSEL_IMAGES, ...CAROUSEL_IMAGES].map((src, idx) => <img key={idx} src={src} alt="" className="h-32 w-24 rounded-2xl object-cover sm:h-48 sm:w-36" data-id="element-230" data-mp="3w2thi6a3b51w" data-mpi={idx} />)}
        </div>
      </div>
    </section>;
}